// Business Configuration for Invoice Generation
export const BUSINESS_CONFIG = {
  name: "A2Z TAK",
  address: {
    line1: "Bahadur Ke Road, Ludhiana",
    line2: "Punjab - 141008",
    phone: "+91 XXXXXXXXXX", // Add your phone number
    email: "info@a2ztak.in"
  },
  gst: {
    number: "GST_NUMBER_HERE", // Replace with your actual GST number
    state: "Punjab",
    stateCode: "03", // Punjab state code
    hsnCode: "8517" // Mobile phones and communication equipment
  },
  bank: {
    name: "Bank Name", // Add your bank name
    accountNumber: "XXXXXXXXXXXX", // Add your account number
    ifsc: "XXXXXXXX", // Add your IFSC code
    branch: "Branch Name" // Add your branch name
  }
};

// You can update these details in this file
// GST State Codes Reference:
// Andhra Pradesh - 37, Arunachal Pradesh - 12, Assam - 18
// Bihar - 10, Chhattisgarh - 22, Goa - 30, Gujarat - 24
// Haryana - 06, Himachal Pradesh - 02, Jharkhand - 20
// Karnataka - 29, Kerala - 32, Madhya Pradesh - 23
// Maharashtra - 27, Manipur - 14, Meghalaya - 17
// Mizoram - 15, Nagaland - 13, Odisha - 21, Punjab - 03
// Rajasthan - 08, Sikkim - 11, Tamil Nadu - 33
// Telangana - 36, Tripura - 16, Uttar Pradesh - 09
// Uttarakhand - 05, West Bengal - 19, Delhi - 07
